import React, { useState, useEffect } from 'react';
import { promoPackService } from '../api/promoPackService';
import Table from '../components/Common/Table';
import Modal from '../components/Common/Modal';
import Pagination from '../components/Common/Pagination';
import SearchBar from '../components/Common/SearchBar';
import PromoPackForm from '../components/PromoPacks/PromoPackForm';
import '../components/Common/Common.css';

function PromoPacks() {
  const [promoPacks, setPromoPacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingPromoPack, setEditingPromoPack] = useState(null);

  const fetchPromoPacks = async () => {
    try {
      setLoading(true);
      const response = await promoPackService.getPromoPacks({
        page: currentPage,
        search: searchTerm,
        per_page: 15,
      });
      setPromoPacks(response.data);
      setLastPage(response.last_page || 1);
    } catch (error) {
      console.error('Error fetching promo packs:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPromoPacks();
  }, [currentPage, searchTerm]);

  const handleDelete = async (id) => {
    if (window.confirm('Êtes-vous sûr de vouloir supprimer ce pack promo ?')) {
      try {
        await promoPackService.deletePromoPack(id);
        fetchPromoPacks();
      } catch (error) {
        console.error('Error deleting promo pack:', error);
        alert('Échec de la suppression du pack promo');
      }
    }
  };

  const handleEdit = async (promoPack) => {
    try {
      const fullData = await promoPackService.getPromoPack(promoPack.id);
      setEditingPromoPack(fullData);
      setShowModal(true);
    } catch (error) {
      console.error('Error fetching promo pack details:', error);
      alert('Échec du chargement des détails du pack promo');
    }
  };

  const handleCreate = () => {
    setEditingPromoPack(null);
    setShowModal(true);
  };

  const handleFormSuccess = () => {
    setShowModal(false);
    setEditingPromoPack(null);
    fetchPromoPacks();
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Nom' },
    {
      key: 'image_url',
      label: 'Image',
      render: (val) => val ? (
        <img src={val} alt="Pack" style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '4px' }} />
      ) : 'Pas d\'image'
    },
    {
      key: 'promo_pack_items',
      label: 'Produits',
      render: (val) => val?.length || 0
    },
    { key: 'promo_price', label: 'Prix promo', render: (val) => `${parseFloat(val).toFixed(2)} DH` },
    { key: 'fake_original_price', label: 'Prix original', render: (val) => val ? `${parseFloat(val).toFixed(2)} DH` : 'N/A' },
    {
      key: 'is_active',
      label: 'Statut',
      render: (val) => <span className={`badge ${val ? 'badge-success' : 'badge-danger'}`}>{val ? 'Actif' : 'Inactif'}</span>
    },
  ];

  return (
    <div>
      <div className="page-header">
        <h1>Packs promo</h1>
        <button onClick={handleCreate} className="btn btn-primary">
          Ajouter un pack promo
        </button>
      </div>

      <div className="filters">
        <div className="filters-grid">
          <div style={{ gridColumn: 'span 2' }}>
            <SearchBar
              value={searchTerm}
              onChange={setSearchTerm}
              placeholder="Rechercher des packs promo par nom ou produits..."
              onClear={() => setCurrentPage(1)}
            />
          </div>
        </div>
      </div>

      <Table
        columns={columns}
        data={promoPacks}
        loading={loading}
        onEdit={handleEdit}
        onDelete={handleDelete}
      />

      <Pagination
        currentPage={currentPage}
        lastPage={lastPage}
        onPageChange={setCurrentPage}
      />

      <Modal
        isOpen={showModal}
        onClose={() => { setShowModal(false); setEditingPromoPack(null); }}
        title={editingPromoPack ? 'Modifier le pack promo' : 'Ajouter un pack promo'}
        size="large"
      >
        <PromoPackForm
          promoPack={editingPromoPack}
          onSuccess={handleFormSuccess}
          onCancel={() => { setShowModal(false); setEditingPromoPack(null); }}
        />
      </Modal>
    </div>
  );
}

export default PromoPacks;
